import type React from "react";

import { Route, Routes } from "react-router-dom";

import { Container } from "shared/atoms/Container";
import { usePageContentOffsetTop } from "shared/styles/usePageContentOffsetTop";

import { Settings } from "./views/Settings";

export const SettingsRoutes: React.FC = () => {
  const offsetTop = usePageContentOffsetTop();

  return (
    <Routes>
      <Route
        path="/"
        element={
          <Container $pageContentOffsetTop={offsetTop}>
            <Settings />
          </Container>
        }
      />
    </Routes>
  );
};
